import styled from '@emotion/styled'

import { GridContainer as GridContainerBase } from '@/components/Grid'

import { mediaMax } from '@/styles/mixins'

import {
  Container as BlockTextScrollContainer,
  Content as BlockTextScrollContent,
  ContentClone as BlockTextScrollContentClone
} from '@/components/Block/TextScroll/style'

export const BackgroundImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: -2;
`

export const GridContainer = styled(GridContainerBase)`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  ${mediaMax.xs} {
    height: 100%;
    justify-content: center;
  }
`

export const Wrapper = styled.div`
  position: relative;
  width: 35%;
  padding-top: 45%;
  ${mediaMax.xs} {
    width: 90%;
    padding-top: 0;
    height: auto;
  }
`

export const Image = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  ${mediaMax.xs} {
    position: relative;
  }
`

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
  overflow: hidden;

  ${BlockTextScrollContainer} {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    transform: translate(-50%, -50%);
    ${mediaMax.xs} {
      z-index: 10;
    }
  }

  ${BlockTextScrollContentClone},
  ${BlockTextScrollContent} {
    font-size: 7rem;
    color: ${({ theme }) => theme.colors.white};
    font-weight: bold;
    ${mediaMax.xs} {
      font-size: 5.5rem;
    }
  }

  &.inverted {
    ${GridContainer} {
      justify-content: flex-start;
    }
  }
`

export const CircularLabelButton = styled.div`
  position: absolute;
  top: 100%;
  left: 100%;
  transform: translate(-50%, -50%);
  z-index: 3;
  pointer-events: none;
`
